export default __webpack_public_path__ + "static/caruosel-top-f7010e47abe4220eed10bb8ff129f549.jpg";